$(document).ready(function () {
  let p = $("body").attr("p");
  let event_id = $("body").attr("event_id");

  if (p == "cash_rounding_orders") {
    let start_date = $("#start_date").val();
    let end_date = $("#end_date").val();
    let order_by = $("#order_by").val();
    let order_by_direction = $("#order_by_direction").val();
    let page = $("#page").val();
    let cash_rounding_orders_ajax_lock = false;

    $(document).on("change", "#start_date, #end_date", function () {
      start_date = $("#start_date").val();
      end_date = $("#end_date").val();

      search();
    });

    $(document).on("click", ".sort", function () {
      order_by = $(this).prop("id");
      order_by_direction = $(this).data("order-direction");

      search();
    });

    $(document).on("click", ".pagination a", function (e) {
      e.preventDefault();
      page = parseInt($(this).attr("href").substring(6));

      search();
    });

    $(document).on("click", "#export-cash-roundings", function (e) {
      e.preventDefault();

      const disabledOnClick = $("#export-cash-roundings");
      const btnWidth = disabledOnClick.outerWidth();
      disabledOnClick.css("width", btnWidth + "px");
      disabledOnClick.prop("disabled", true);
      disabledOnClick.html('<i class="spinner-border spinner-border-sm"></i>');

      const url = `/api/v1/private/cash-rounding-orders/download?start=${start_date}&end=${end_date}&location_id=${event_id}`;
      window.location.href = url;

      disabledOnClick.prop("disabled", false);
      disabledOnClick.html("Eksport");
    });

    function search() {
      if (!cash_rounding_orders_ajax_lock) {
        cash_rounding_orders_ajax_lock = true;

        $.ajax({
          type: "POST",
          url: "/api/v1/private/cash-rounding-orders/search",
          data: {
            start_date,
            end_date,
            order_by,
            order_by_direction: order_by_direction.toUpperCase(),
            page,
          },
        })
          .done(function (data) {
            if (
              data.html != undefined &&
              data.html != null &&
              data.html != ""
            ) {
              $("#cash-rounding-order-list").html(data.html);
            }
          })
          .always(function () {
            cash_rounding_orders_ajax_lock = false;
          });
      }
    }
  }
});
